export default __webpack_public_path__ + "static/media/logoImpactoolsConexao.2f7d29ae.svg";